import React from 'react';

class SeasonsDropdown extends React.Component {

  constructor(props) {
		super(props);
		this.seasonChange = this.seasonChange.bind(this);
		this.createSelectItem = this.createSelectItem.bind(this);
	}

	seasonChange(event) {
		var seasonId = event.target.value;
		this.props.seasonChange(seasonId);
	}

	render() {
		//console.log('SeasonsDropdown: render')
		return (
			<select className="form-control" value={this.props.value} onChange={this.seasonChange}>
				{this.props.seasons.map(this.createSelectItem)}
			</select>
		);
	}
	
	createSelectItem(season) {
		return (
			<option value={season._id} key={season._id}>{season.name}</option>
		);
	}

}

export default SeasonsDropdown;